(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
